import * as Sentry from '@sentry/vue';

export default defineNuxtPlugin((nuxtApp) => {
  const runtimeConfig = useRuntimeConfig();
  const router = useRouter();
  const { vueApp } = nuxtApp;

  if (!runtimeConfig.public.SENTRY_DSN) {
    return;
  }

  Sentry.init({
    app: nuxtApp.vueApp,
    dsn: runtimeConfig.public.SENTRY_DSN,
    environment: runtimeConfig.public.SENTRY_ENVIRONMENT,
    beforeSend(event) {
      const isGoogleAnalyticsUrl = event.request?.url?.includes('google-analytics');
      if (runtimeConfig.public.IS_LOCAL_HOST) {
        return null;
      }

      if (isGoogleAnalyticsUrl) {
        return null;
      }
      return event;
    },
    sendDefaultPii: true,
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
      Sentry.httpClientIntegration({
        failedRequestStatusCodes: [400, 500],
      }),
    ],
    sampleRate: 0.3,
    tracePropagationTargets: ['localhost'],
    tracesSampleRate: 0.001,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0.1,
  });

  vueApp.mixin(Sentry.createTracingMixins({ trackComponents: true, timeout: 2000, hooks: ['activate', 'mount', 'update'] }));
  Sentry.attachErrorHandler(
    vueApp,
    {
      logErrors: false,
      attachProps: true,
      trackComponents: true,
      timeout: 2000,
      hooks: ['activate', 'mount', 'update'],
      attachErrorHandler: true,
    },
  );

  return {
    provide: {
      addBreadCrumbs: Sentry.addBreadcrumb,
      sentrySetUser: Sentry.setUser,
      sendErrorToSentry: Sentry.captureException,
    },
  };
});
